import React from 'react';
import './Management.css';
import FMSimage from '../Assets/manage1.jpg'; // First image
import FMSimage2 from '../Assets/manage2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/fd4.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/manage5.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/fd5.jpg'; // Image for Industries section

const ManagementOfLightsAndAC = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">SMART LIGHTING AND AIRCON CONTROL</h1>
                        <p className="FMS-description">
                            The Smart Lighting and Aircon Control system from Vajra IoT optimizes energy usage and enhances safety in homes and commercial spaces. With remote control, programmable settings, and smart features, it reduces electricity costs, particularly in commercial buildings where lighting accounts for 40% of energy expenses, while ensuring a safe and comfortable environment.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Smart Lighting and Aircon Control" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Aircon Remote Control:</strong> On/off and reset functions to manage aircon issues or hang states.</li>
                                <li><strong>Programmable Temperature Thresholds:</strong> Set dynamic temperature ranges with real-time alerts.</li>
                                <li><strong>Dimming:</strong> Adjust lighting brightness to save energy.</li>
                                <li><strong>Remote Control:</strong> Manage lights and aircon from anywhere via mobile or web.</li>
                                <li><strong>Adjustable Brightness:</strong> Customize lighting levels for comfort and efficiency.</li>
                                <li><strong>Scheduling:</strong> Automate on/off times for lights and aircon to reduce waste.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: New Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            The system integrates smart controllers for aircon and lighting. Users set temperature thresholds and receive alerts for anomalies, with remote on/off and reset options for aircon. Lighting can be dimmed, brightened, or scheduled via a mobile app or web interface. Automated schedules optimize energy use, while real-time monitoring ensures safety and efficiency.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Our Management Solution */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Smart Control Solution</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Energy Savings:</strong> Reduces electricity costs through dimming, scheduling, and temperature control.</li>
                                <li><strong>Safety:</strong> Ensures safe environments with real-time monitoring and alerts.</li>
                                <li><strong>Convenience:</strong> Remote control and automation simplify management.</li>
                                <li><strong>Commercial Benefits:</strong> Cuts 40% of lighting energy costs in commercial settings and supports new applications.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Smart Control" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our Management Solution */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our Smart Control Solution</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using Smart Control" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Smart Lighting and Aircon Control Solution is trusted across industries for energy efficiency and safety. These sectors benefit from reduced costs and enhanced control:
                            <ul>
                                <li>Commercial Buildings</li>
                                <li>Offices</li>
                                <li>Residential Properties</li>
                                <li>Hospitality</li>
                                <li>Retail</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManagementOfLightsAndAC;